export default __webpack_public_path__ + "static/media/road-crossing.a05231a8.png";